import type { Recipe } from '../types';

export const starterRecipes: Omit<Recipe, 'id'>[] = [
    {
        name: 'עוגת ביסקוויטים קלאסית',
        servings: 12,
        category: 'Dessert',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'פתי-בר', quantity: 500, unit: 'g', isMeat: false, section: 'בסיס' },
            { name: 'שמנת מתוקה', quantity: 500, unit: 'ml', isMeat: false, section: 'קרם' },
            { name: 'חלב', quantity: 250, unit: 'ml', isMeat: false, section: 'קרם' },
            { name: 'אינסטנט פודינג וניל', quantity: 1, unit: 'package', isMeat: false, section: 'קרם' },
            { name: 'שוקולד מריר', quantity: 100, unit: 'g', isMeat: false, section: 'ציפוי' },
            { name: 'חמאה', quantity: 50, unit: 'g', isMeat: false, section: 'ציפוי' }
        ],
        instructions: '1. מקציפים שמנת, חלב ופודינג לקרם יציב.\n2. טובלים ביסקוויטים בחלב ומסדרים בתבנית.\n3. מורחים שכבת קרם וחוזרים על הפעולה.\n4. ממיסים שוקולד וחמאה ושופכים מעל.',
        links: ['https://www.mako.co.il/food-recipes/recipes_column-desserts/Recipe-992321ef75eea31006.htm']
    },
    {
        name: 'בראוניז שוקולד',
        servings: 24,
        category: 'Dessert',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'שוקולד מריר', quantity: 200, unit: 'g', isMeat: false, section: 'בלילה' },
            { name: 'חמאה', quantity: 150, unit: 'g', isMeat: false, section: 'בלילה' },
            { name: 'סוכר', quantity: 200, unit: 'g', isMeat: false, section: 'בלילה' },
            { name: 'ביצים', quantity: 3, unit: 'unit', isMeat: false, section: 'בלילה' },
            { name: 'קמח', quantity: 140, unit: 'g', isMeat: false, section: 'בלילה' }
        ],
        instructions: '1. ממיסים שוקולד וחמאה.\n2. מוסיפים סוכר וביצים וטורפים היטב.\n3. מקפלים פנימה קמח.\n4. אופים ב-180 מעלות כ-20-25 דקות.',
        links: ['https://chef-lavan.co.il/%D7%A7%D7%99%D7%A0%D7%95%D7%97%D7%99%D7%9D/%D7%A2%D7%95%D7%92%D7%95%D7%AA/%D7%A2%D7%95%D7%92%D7%95%D7%AA-%D7%A9%D7%95%D7%A7%D7%95%D7%9C%D7%93/%D7%91%D7%A8%D7%90%D7%95%D7%A0%D7%99%D7%96-%D7%98%D7%A2%D7%99%D7%9E%D7%99%D7%9D-%D7%95%D7%A7%D7%9C%D7%99%D7%9D-%D7%9C%D7%94%D7%9B%D7%A0%D7%94/']
    },
    {
        name: 'כדורי שוקולד של פעם',
        servings: 30,
        category: 'Dessert',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'ביסקוויטים', quantity: 250, unit: 'g', isMeat: false, section: 'בסיס' },
            { name: 'חמאה', quantity: 100, unit: 'g', isMeat: false, section: 'רוטב' },
            { name: 'סוכר', quantity: 100, unit: 'g', isMeat: false, section: 'רוטב' },
            { name: 'קקאו', quantity: 3, unit: 'tbsp', isMeat: false, section: 'רוטב' },
            { name: 'חלב', quantity: 120, unit: 'ml', isMeat: false, section: 'רוטב' }
        ],
        instructions: '1. טוחנים את הביסקוויטים.\n2. ממיסים חמאה, חלב, סוכר וקקאו.\n3. מערבבים הכל יחד, יוצרים כדורים ומצפים בקוקוס.',
        links: ['https://chef-lavan.co.il/%D7%A7%D7%99%D7%A0%D7%95%D7%97%D7%99%D7%9D/%D7%A7%D7%99%D7%A0%D7%95%D7%97%D7%99%D7%9D-%D7%90%D7%99%D7%A9%D7%99%D7%99%D7%9D/%D7%9B%D7%93%D7%93%D7%95%D7%A8%D7%99-%D7%A9%D7%95%D7%A7%D7%95%D7%9C%D7%937/']
    },
    {
        name: 'פיצה ביתית של קרן אגם',
        servings: 8,
        category: 'Meal',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'קמח', quantity: 500, unit: 'g', isMeat: false, section: 'בצק' },
            { name: 'שמרים יבשים', quantity: 1, unit: 'tbsp', isMeat: false, section: 'בצק' },
            { name: 'מים', quantity: 300, unit: 'ml', isMeat: false, section: 'בצק' },
            { name: 'שמן זית', quantity: 3, unit: 'tbsp', isMeat: false, section: 'בצק' },
            { name: 'מוצרלה', quantity: 300, unit: 'g', isMeat: false, section: 'תוספות' }
        ],
        instructions: '1. לשים בצק מכל המרכיבים ומתפיחים שעה.\n2. מחלקים ל-2 כדורים ופותחים לעיגולים.\n3. מורחים רוטב וגבינה ואופים בחום מקסימלי.',
        links: ['https://kerenagam.co.il/%D7%A4%D7%99%D7%A6%D7%94-%D7%91%D7%99%D7%AA%D7%99%D7%AA-%D7%9E%D7%93%D7%94%D7%99%D7%9E%D7%94/']
    },
    {
        name: 'פוקאצ׳ה אוורירית',
        servings: 3,
        category: 'Side',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'קמח לחם', quantity: 500, unit: 'g', isMeat: false, section: 'בצק' },
            { name: 'שמרים', quantity: 10, unit: 'g', isMeat: false, section: 'בצק' },
            { name: 'מלח', quantity: 10, unit: 'g', isMeat: false, section: 'בצק' },
            { name: 'שמן זית', quantity: 50, unit: 'ml', isMeat: false, section: 'בצק' }
        ],
        instructions: '1. לשים בצק רך מאוד ומתפיחים.\n2. יוצרים צורות מאורכות ומטביעים אצבעות.\n3. מברישים בהרבה שמן זית ומלח גס.',
        links: ['https://elitaofek.co.il/%D7%A4%D7%95%D7%A7%D7%A6%D7%B3%D7%94-%D7%90%D7%95%D7%95%D7%A8%D7%99%D7%A8%D7%99%D7%AA-%D7%91%D7%9C%D7%99-%D7%9E%D7%99%D7%A7%D7%A1%D7%A8/']
    },
    {
        name: 'פנה ברוטב רוזה',
        servings: 4,
        category: 'Meal',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'פסטה פנה', quantity: 500, unit: 'g', isMeat: false, section: 'עיקרית' },
            { name: 'עגבניות מרוסקות', quantity: 400, unit: 'g', isMeat: false, section: 'רוטב' },
            { name: 'שמנת לבישול', quantity: 250, unit: 'ml', isMeat: false, section: 'רוטב' },
            { name: 'שום', quantity: 2, unit: 'clove', isMeat: false, section: 'רוטב' }
        ],
        instructions: '1. מבשלים פסטה.\n2. מחממים שום ועגבניות, מוסיפים שמנת ומביאים לסף רתיחה.\n3. מערבבים עם הפסטה.',
        links: ['https://www.mako.co.il/food-cooking_magazine/recipes_by_rotem_liberzon/Recipe-3719579cc8a3f71026.htm']
    },
    {
        name: 'קאצ׳ו א-פפה',
        servings: 4,
        category: 'Meal',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'ספגטי', quantity: 400, unit: 'g', isMeat: false, section: 'עיקרית' },
            { name: 'גבינת פקורינו', quantity: 150, unit: 'g', isMeat: false, section: 'רוטב' },
            { name: 'פלפל שחור גרוס', quantity: 1, unit: 'tbsp', isMeat: false, section: 'רוטב' }
        ],
        instructions: '1. קולים פלפל שחור במחבת.\n2. מבשלים פסטה ושומרים מי בישול.\n3. מערבבים פסטה, מים וגבינה עד לקבלת קרם.',
        links: ['https://chef-lavan.co.il/%D7%A2%D7%99%D7%A7%D7%A8%D7%99%D7%95%D7%AA/%D7%A4%D7%A1%D7%98%D7%95%D7%AA/%D7%A4%D7%A1%D7%98%D7%95%D7%AA-%D7%A0%D7%95%D7%A1%D7%A4%D7%95%D7%AA/%D7%A7%D7%90%D7%A6-%D7%95-%D7%90%D7%94-%D7%A4%D7%A4%D7%94/']
    },
    {
        name: 'לזניה לילדים',
        servings: 10,
        category: 'Meal',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'דפי לזניה', quantity: 1, unit: 'package', isMeat: false, section: 'בסיס' },
            { name: 'גבינת קוטג׳', quantity: 500, unit: 'g', isMeat: false, section: 'מלית' },
            { name: 'גבינה צהובה', quantity: 200, unit: 'g', isMeat: false, section: 'מלית' },
            { name: 'רסק עגבניות', quantity: 200, unit: 'g', isMeat: false, section: 'רוטב' }
        ],
        instructions: '1. מערבבים קוטג׳ עם ביצה ותבלינים.\n2. מסדרים שכבות של דפים, רוטב ומלית גבינות.\n3. אופים 40 דקות ב-180 מעלות.',
        links: ['https://chef-lavan.co.il/%D7%A2%D7%99%D7%A7%D7%A8%D7%99%D7%95%D7%AA/%D7%A4%D7%A1%D7%98%D7%95%D7%AA/%D7%9C%D7%96%D7%A0%D7%99%D7%94/%D7%9C%D7%96%D7%A0%D7%99%D7%94-%D7%9C%D7%99%D7%9C%D7%93%D7%99%D7%9D9003/']
    },
    {
        name: 'סלט פנצנלה ישראלי',
        servings: 6,
        category: 'Side',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'עגבניות', quantity: 4, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'בצל סגול', quantity: 1, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'לחם ישן (קרוטונים)', quantity: 2, unit: 'cup', isMeat: false, section: 'בסיס' },
            { name: 'בזיליקום', quantity: 1, unit: 'bunch', isMeat: false, section: 'ירקות' }
        ],
        instructions: '1. חותכים ירקות גס.\n2. קולים קוביות לחם בשמן זית.\n3. מערבבים הכל עם חומץ בלסמי ושמן זית.',
        links: ['https://www.elinaskitchen.com/post/%D7%A1%D7%9C%D7%98-%D7%A4%D7%A0%D7%A6%D7%A0%D7%9C%D7%94-%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99-%D7%A1%D7%9C%D7%98-%D7%9C%D7%97%D7%9D-%D7%90%D7%99%D7%98%D7%9C%D7%A7%D7%99-%D7%91%D7%92%D7%A8%D7%A1%D7%94-%D7%98%D7%A2%D7%99%D7%9E%D7%94-%D7%95%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99%D7%AA-%D7%A2%D7%9D-%D7%A7%A8%D7%95%D7%98%D7%95%D7%A0%D7%99%D7%9D-%D7%9E%D7%A4%D7%A0%D7%A7%D7%99%D7%9D']
    },
    {
        name: 'סלט חסה רענן',
        servings: 8,
        category: 'Side',
        isKeto: true,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'חסה', quantity: 1, unit: 'head', isMeat: false, section: 'ירקות' },
            { name: 'צנונית', quantity: 4, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'אגוזי מלך', quantity: 50, unit: 'g', isMeat: false, section: 'תוספות' }
        ],
        instructions: '1. קורעים חסה.\n2. מכינים רוטב מויניגרט דבש וחרדל.\n3. מערבבים סמוך להגשה.',
        links: ['https://www.haaretz.co.il/food/touchfood/2017-08-03/ty-article/0000017f-f8bd-d318-afff-fbfff1480000']
    },
    {
        name: 'אנטי פסטי בתנור',
        servings: 6,
        category: 'Side',
        isKeto: true,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'פלפלים צבעוניים', quantity: 3, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'בטטה', quantity: 2, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'קישואים', quantity: 3, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'בצל', quantity: 2, unit: 'unit', isMeat: false, section: 'ירקות' }
        ],
        instructions: '1. פורסים את הירקות.\n2. מתבלים בשמן זית, מלח גס וטימין.\n3. צולים ב-200 מעלות עד להזהבה.',
        links: ['https://www.haaretz.co.il/food/recipes/2012-02-22/ty-article/0000017f-f861-ddde-abff-fc6557a40000']
    },
    {
        name: 'סלט פסטה פסטו',
        servings: 6,
        category: 'Side',
        isKeto: false,
        isPublic: false,
        ownerId: '',
        householdId: '',
        originLanguage: 'he',
        ingredients: [
            { name: 'פסטה קצרה', quantity: 500, unit: 'g', isMeat: false, section: 'עיקרית' },
            { name: 'רוטב פסטו', quantity: 4, unit: 'tbsp', isMeat: false, section: 'רוטב' },
            { name: 'עגבניות שרי', quantity: 20, unit: 'unit', isMeat: false, section: 'ירקות' },
            { name: 'צנוברים', quantity: 30, unit: 'g', isMeat: false, section: 'תוספות' }
        ],
        instructions: '1. מבשלים ומקררים פסטה.\n2. מערבבים עם פסטו, חצאי שרי וצנוברים קלויים.',
        links: ['https://www.alonaeck.com/post/%D7%A1%D7%9C%D7%98-%D7%A4%D7%A1%D7%98%D7%94-%D7%A4%D7%A1%D7%98%D7%95']
    }
];